<template>
  <b-card
    v-if="data"
    no-body
    class="card-statistics"
  >
<!--    <b-card-header>-->
<!--&lt;!&ndash;      <b-card-title>آمار</b-card-title>&ndash;&gt;-->
<!--    </b-card-header>-->
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          xl="2"
          lg="2"
          md="4"
          sm="6"
          class="mb-1 cursor-pointer"
          @click="goTo('/tasks/inbox')"
        >
          <b-media no-body >
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-info"
              >
                <feather-icon
                  size="24"
                  icon="CheckSquareIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.allTasks }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                کل وظایف
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="2"
          lg="2"
          md="4"
          sm="6"
          class="mb-1 cursor-pointer"
          @click="goTo('/tasks/inbox')"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-warning"
              >
                <feather-icon
                  size="24"
                  icon="TrelloIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.openTasks }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                وظایف باز
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="2"
          lg="2"
          md="4"
          sm="6"
          class="mb-1 cursor-pointer"
          @click="goTo('/tickets/inbox')"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-primary"
              >
                <feather-icon
                  size="24"
                  icon="MailIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.allTickets }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                 نامه های من
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="2"
          lg="2"
          md="4"
          sm="6"
          class="mb-1 cursor-pointer"
          @click="goTo('/tickets/sent')"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-success"
              >
                <feather-icon
                  size="24"
                  icon="SendIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.allSentTickets }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                 نامه های ارسالی
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="2"
          lg="2"
          md="4"
          sm="6"
          class="mb-1 cursor-pointer"
          @click="goTo('/tickets/inbox',{unseen:1})"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-danger"
              >
                <feather-icon
                  size="24"
                  icon="EyeOffIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.unSeenTickets }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                 نامه های خوانده نشده
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="2"
          lg="2"
          md="4"
          sm="6"
          class="mb-1 cursor-pointer"

          @click="goTo('/tickets/inbox',{isClosed:1})"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-secondary"
              >
                <feather-icon
                  size="24"
                  icon="PhoneMissedIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.closedTickets }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                 نامه های بسته شده
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    data: {
      type: Object,
      default: () => {},},
  },
  methods:{
    goTo(path, params) {
      this.$router.push({path:path,query:params})
    },
  }
}
</script>
